import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from "@cinch-labs/design-system";
import styles from "./social-media-link.module.css";
var SocialMediaLink = function(param) {
    var name = param.name, href = param.href, icon = param.icon;
    var youtubeViewBox = "0 0 34 24";
    var defaultViewBox = "0 0 24 24";
    var isYoutube = name === "YouTube";
    return /*#__PURE__*/ _jsx("li", {
        className: styles.item,
        children: /*#__PURE__*/ _jsx("a", {
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": name,
            children: /*#__PURE__*/ _jsx(SvgIcon, {
                name: icon,
                color: "pureWhite",
                width: isYoutube ? 34 : 24,
                viewBox: isYoutube ? youtubeViewBox : defaultViewBox
            })
        })
    });
};
export default SocialMediaLink;
